import { z } from 'zod';

export const orderRegistrationSchema = z.object({
  wanted: z.string(),
  targetDate: z.date().nullable(),
  targetTime: z.date().nullable(),
  work: z.string(),
  totalVehicle: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
  amount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
  orders: z.array(
    z.object({
      targetDate: z.date().nullable(),
      targetTime: z.date().nullable(),
      work: z.string(),
      totalVehicle: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
      amount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
    }),
  ),
});

export const orderUpdatedSchema = z.object({
  wanted: z.string(),
  targetDate: z.date().nullable(),
  targetTime: z.date().nullable(),
  work: z.string(),
  totalVehicle: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
  amount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
});

export const NotificationSchema = z
  .object({
    radioBtnItems: z.enum(['1', '2', '3', '4'], {
      errorMap: () => ({ message: '라디오 버튼 중 하나를 선택해야 합니다.' }),
    }),
    targetTime: z.date().nullable().optional(),
    notificationTxt: z
      .string()
      .max(20, '최대 20자까지 입력할 수 있습니다.')
      .optional(),
  })
  .refine(
    (data) => {
      if (data.radioBtnItems === '1') {
        return data.targetTime !== null; // '도착시간 변경 알림'의 경우 targetTime이 필수
      }
      return true;
    },
    {
      path: ['targetTime'],
      message: '도착시간을 입력해주세요.',
    },
  )
  .refine(
    (data) => {
      if (data.radioBtnItems === '3') {
        return data.notificationTxt !== ''; // '안내문구 알림'의 경우 notificationTxt가 필수
      }
      return true;
    },
    {
      path: ['notificationTxt'],
      message: '알림 문구를 입력해주세요.',
    },
  );

export const CheckListSchema = z.object({
  vehicle: z.array(z.string()).min(1, '차량을 최소 하나는 선택해야 합니다.'), // 최소 하나의 항목이 필요
});
